export function getAssetCount(assets) {
  const uniqueCoreAssets = new Set(
    assets.map(({ uuid }) => uuid).filter((uuid) => !!uuid),
  );

  return uniqueCoreAssets.size;
}
